import React, { Fragment, useState, useEffect } from "react";
import Header2 from "../../components/Header2/Header2";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  Typography,
  Box,
  Paper,
  Link as MUILink,
  Divider,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Button,
  Chip,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SearchFilterSection from "./SearchFilterSection";
import SEO from "../../components/SEO";
import JobListingSection from "./JobListingSection";
import Search from "./Search";
import { Link } from "react-router-dom";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import StarIcon from "@mui/icons-material/Star";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import SortIcon from "@mui/icons-material/Sort";
import CloseIcon from "@mui/icons-material/Close";
import { display, fontSize, keyframes } from "@mui/system";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import careerAd from "../../images/career-ad.jpg";

// Priority Jobs Recommendation component remains unchanged
const PriorityJobsRecommendation = ({ jobs, handleApply }) => {
  const theme = useTheme();
  const scrollRef = React.useRef(null);

  const priorityJobs = jobs.filter((job) => job.priority === true);

 


  useEffect(() => {
  const container = scrollRef.current;
  if (!container) return;

  let isPaused = false;

  const handleMouseEnter = () => (isPaused = true);
  const handleMouseLeave = () => (isPaused = false);

  container.addEventListener("mouseenter", handleMouseEnter);
  container.addEventListener("mouseleave", handleMouseLeave);

  const intervalId = setInterval(() => {
    if (!isPaused) {
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      if (container.scrollLeft >= maxScrollLeft) {
        container.scrollTo({ left: 0, behavior: "smooth" }); // Reset
      } else {
        container.scrollBy({ left: 300, behavior: "smooth" }); // Scroll right
      }
    }
  }, 3000); // every 3 seconds

  return () => {
    clearInterval(intervalId);
    container.removeEventListener("mouseenter", handleMouseEnter);
    container.removeEventListener("mouseleave", handleMouseLeave);
  };
}, []);

 if (priorityJobs.length === 0) {
    return null;
  }

  const handleScrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

 const handleScrollRight = () => {
  if (scrollRef.current) {
    const container = scrollRef.current;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    if (container.scrollLeft >= maxScrollLeft) {
      container.scrollTo({ left: 0, behavior: "smooth" }); // reset to start
    } else {
      container.scrollBy({ left: 300, behavior: "smooth" });
    }
  }
};

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        mb: 3,
        borderRadius: 2,
        // backgroundColor: "background.paper",
        backgroundColor: "#fff3ea",
        position: "relative",
        boxShadow: "none",
        border: "solid 1px #ed6c02",
      }}
    >
      <Typography
        variant="h6"
        color="primary"
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: 600,
          borderBottom: "2px solid",
          // borderColor: "primary.main",
          borderColor: "#ed6c02",
          color: "#ed6c02",
          pb: 1,
        }}
      >
        {/* <StarIcon sx={{ mr: 1, color: theme.palette.warning.main }} /> */}
        Urgent Hiring
        <Chip
          label={`${priorityJobs.length} Jobs`}
          size="small"
          //color="primary"
          variant="outlined"
          sx={{
            ml: 2,
            borderRadius: "4px",
            backgroundColor: "#fff",
            border: "solid 1px #ed6c02",
            color: "#ed6c02",
          }}
        />
      </Typography>

      <Box sx={{ position: "relative" }}>
        <IconButton
          onClick={handleScrollLeft}
          sx={{
            position: "absolute",
            left: -16,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 2,
            backgroundColor: "background.paper",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "primary.light",
            },
          }}
          size="small"
        >
          <NavigateBeforeIcon />
        </IconButton>

        <Box
          ref={scrollRef}
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollbarWidth: "none", // Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari, Edge
            },
            px: 2,
            py: 1,
            gap: 2,
          }}
        >
          {priorityJobs.map((job) => (
            <Card
              key={job._id}
              sx={{
                minWidth: 280,
                maxWidth: 300,
                // borderLeft: "4px solid",
                // borderColor: "primary.main",
                border: "solid 1px #bbbbbb",
                backgroundColor: "#fff",
                boxShadow: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: 4,
                },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardContent sx={{ flexGrow: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    color="text.primary"
                    sx={{
                      fontWeight: 600,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      lineHeight: "normal",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      height: "40px",
                    }}
                  >
                    {job.title}
                  </Typography>
                  <StarIcon
                    sx={{ color: theme.palette.warning.main, fontSize: "1rem" }}
                  />
                </Box>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  {job.department}
                </Typography>

                <Box
                  sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}
                >
                  <Chip
                    label={job.jobType}
                    size="small"
                    sx={{
                      fontSize: "0.7rem",
                      height: "20px",
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.contrastText,
                    }}
                  />
                  <Chip
                    label={job.location}
                    size="small"
                    sx={{
                      fontSize: "0.7rem",
                      height: "20px",
                      backgroundColor: theme.palette.secondary.light,
                      color: theme.palette.secondary.contrastText,
                    }}
                  />
                </Box>

                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "block",
                    mb: 2,
                    fontStyle: "italic",
                  }}
                >
                  Experience: {job.experience}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      fontWeight: 600,
                    }}
                  >
                    Openings: {job.numberOfOpenings || 1}
                  </Typography>
                </Box>
              </CardContent>

              <Box sx={{ p: 1, pt: 0 }}>
                <Button
                  sx={{ color: "#ed6c02", border: "solid 1px #ed6c02" }}
                  variant="outlined"
                  //color="primary"
                  fullWidth
                  onClick={() => handleApply(job)}
                  size="small"
                >
                  Apply Now
                </Button>
              </Box>
            </Card>
          ))}
        </Box>

        <IconButton
          onClick={handleScrollRight}
          sx={{
            position: "absolute",
            right: -16,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 2,
            backgroundColor: "background.paper",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "primary.light",
            },
          }}
          size="small"
        >
          <NavigateNextIcon />
        </IconButton>
      </Box>
    
    </Paper>
  );
};

// Fixed More Jobs Sidebar that shows random jobs
const MoreJobsSidebar = ({ allJobs, handleApply }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [randomJobs, setRandomJobs] = useState([]);
  const [refreshRandom, setRefreshRandom] = useState(0);

  // Moved useEffect before early return to fix the React Hook rule violation
  useEffect(() => {
    // Function to get random jobs
    const getRandomJobs = () => {
      const shuffled = [...allJobs].sort(() => 0.5 - Math.random());
      setRandomJobs(shuffled.slice(0, 15)); // Show 15 random jobs
    };

    getRandomJobs();
  }, [allJobs, refreshRandom]);

  // If no desktop view or no jobs, return null
  if (!isDesktop || allJobs.length === 0) {
    return null;
  }

  const handleRefreshRandomJobs = () => {
    setRefreshRandom((prev) => prev + 1);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        borderRadius: 2,
        backgroundColor: "background.paper",
        // position: "sticky",
        // top: "100px", // This will keep the element 100px from the top when scrolling
        maxHeight: "calc(100vh - 120px)", // Limit height to viewport minus some space
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h6"
        color="primary"
        fontSize={18}
        sx={{
          mb: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: 600,
          borderBottom: "2px solid",
          borderColor: "primary.main",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", color: "#333" }}>
          {/* <WorkOutlineIcon sx={{ mr: 1 }} /> */}
          More Jobs
        </Box>
        <IconButton
          size="small"
          onClick={handleRefreshRandomJobs}
          title="Refresh random jobs"
          sx={{
            p: 0.5,
            "&:hover": {
              backgroundColor: "primary.light",
              color: "white",
            },
          }}
        >
          <ShuffleIcon sx={{ fontSize: "1rem" }} />
        </IconButton>
      </Typography>

      <Box
        sx={{
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)", // Adjust based on your layout
          pr: 1,
          flexGrow: 1,
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "primary.light",
            borderRadius: "3px",
          },
        }}
      >
        {randomJobs.map((job) => (
          <React.Fragment key={job._id}>
            <MUILink
              component={Link}
              to={`/apply/${job.slug}`}
              sx={{
                display: "block",
                p: 1,
                borderRadius: 1,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "action.hover",
                  transform: "translateX(5px)",
                  textDecoration: "none",
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.primary"
                sx={{
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {job.title}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display: "block",
                    fontSize: "0.7rem",
                  }}
                >
                  {job.department}
                </Typography>
                <Chip
                  label={job.jobType}
                  size="small"
                  sx={{
                    fontSize: "0.6rem",
                    height: "16px",
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.contrastText,
                  }}
                />
              </Box>
            </MUILink>
            <Divider light />
          </React.Fragment>
        ))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          startIcon={<ShuffleIcon />}
          onClick={handleRefreshRandomJobs}
        >
          Show More
        </Button>
      </Box>
    </Paper>
  );
};

const CareerPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [countries, setCountries] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const jobsPerPage = 6; // Updated to 25 jobs per page

  // Filter states
  const [search, setSearch] = useState("");
  const [experience, setExperience] = useState("");
  const [skillset, setSkillset] = useState("");
  const [location, setLocation] = useState("");
  const [jobType, setJobType] = useState("");
  const [department, setDepartment] = useState("");
  const [sortOrder, setSortOrder] = useState("");
   const [jobMode, setJobMode] = useState("");

  const handleApply = (job) => {
    navigate(`/apply/${job.slug}`, { state: { job } });
  };

  // Fetch jobs function
  const fetchJobs = () => {
    fetch(`${process.env.REACT_APP_BACKEND_BASEURL}/api/jobs`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setJobs(data.data);
          applyFilters(data.data);
        } else {
          console.error("Failed to fetch jobs:", data.message);
        }
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
        setJobs([]);
        setFilteredJobs([]);
      });
  };

  // Sort options
  const sortOptions = [
    { value: "newest", label: "Newest to Oldest" },
    { value: "oldest", label: "Oldest to Newest" },
  ];

  useEffect(() => {
    fetchJobs();
    const refreshInterval = setInterval(() => {
      fetchJobs();
    }, 60000);
    return () => clearInterval(refreshInterval);
  }, [refreshTrigger]);

  useEffect(() => {
    fetch("https://restcountries.com/v3.1/all")
      .then((res) => res.json())
      .then((data) => {
        const countryNames = data.map((country) => country.name.common).sort();
        setCountries(countryNames);
      })
      .catch((err) => {
        console.error("Error fetching countries:", err);
        setCountries([]);
      });
  }, []);

  const experiences = [
    "Fresher",
    "Early Professional",
    "Mid Level",
    "Senior",
    "Super Senior",
  ];
  const skillsets = [
    "Java Dev",
    "Python Dev",
    "Full Stack Dev",
    "Frontend Dev",
    "Backend Dev",
    "ML Eng",
    "DevOps",
    "Cyber Sec",
    "Customer Service",
    "Operations",
    "Marketing",
    "Sales",
  ];
  const jobTypeOptions = [
    "Full Time",
    "Part Time",
    "Contract",
    "Consultant",
    "Freelancer",
    "Internship",
  ];
  const jobModeOptions = [
    "Remote",
    "Onsite",
    "Hybrid",
  ];
  const departmentOptions = [
    "HR",
    "Accounting Finance",
    "Marketing",
    "Sales",
    "IT Tech Services",
    "Customer Service",
    "Operations",
    // "Research and Development (R&D)",
    "Product Management",
    "Engineering",
    // "Supply Chain Management",
    // "Logistics",
    // "Public Relations (PR)",
    "Quality Assurance (QA)",
    "Administration",
    "Design",
    "Project Management",
    // "Compliance",
    "Training and Development",
    "Contact Center (CX)",
    "Information technology"

    // "Software Development",
    // "AI & Automation",    
    // "Education",
    // "Telecom",    
    // "health Care",

  ];

  const applyFilters = (jobsToFilter = jobs) => {
    let filtered = jobsToFilter.filter((job) => {
      const searchTerms = search.toLowerCase().trim();
      const searchMatch = !searchTerms
        ? true
        : [
            job.title,
            job.experience,
            job.skillset,
            job.location,
            job.jobType,
            job.jobMode,
            job.department,
          ].some(
            (field) =>
              field && field.toString().toLowerCase().includes(searchTerms)
          );

      const experienceMatch = !experience || job.experience === experience;
      const skillsetMatch =
        !skillset || (job.skillset && job.skillset.includes(skillset));
      const locationMatch = !location || job.location === location;
      const jobTypeMatch = !jobType || job.jobType === jobType;
      const jobModeMatch = !jobMode || job.jobMode === jobMode;
      const departmentMatch = !department || job.department === department;

      return (
        searchMatch &&
        experienceMatch &&
        skillsetMatch &&
        locationMatch &&
        jobTypeMatch &&
        jobModeMatch &&
        departmentMatch
      );
    });

    if (sortOrder === "newest") {
      filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else if (sortOrder === "oldest") {
      filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    }

    setFilteredJobs(filtered);
  };

  const clearFilters = () => {
    setSearch("");
    setExperience("");
    setSkillset("");
    setLocation("");
    setJobType("");
    setDepartment("");
    setSortOrder("");
    setFilteredJobs(jobs);
    setCurrentPage(1);
    setJobMode("");
  };

  useEffect(() => {
    applyFilters();
  }, [search, experience, skillset, location, jobType, jobMode, department, sortOrder]);

  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  // Pagination logic
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalJobs = filteredJobs.length; // Get the total number of jobs
  const totalPages = Math.ceil(totalJobs / jobsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  //for card closed
  const [isVisible, setIsVisible] = useState(true);

  const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

  return (
    <Fragment>
      <SEO
        title="Unified Consultancy Services | Strategic Consulting for Growth and Success"
        description="Join Unified Consultancy Services and grow your career in software development, AI, DevOps, and cybersecurity."
        url="https://www.ufsnetworks.com/career"
        image="https://texora.s3.ap-south-1.amazonaws.com/ufs_logo.jpg"
        canonicalUrl="https://www.ufsnetworks.com/career"
      />
      <Header2 />
      <PageTitle
        pageTitle={"Unified Job Portal | ATS"}
        pagesub={"Explore Career Opportunities"}
        pageTop={""}
      />
      <Container maxWidth="xl p-0" sx={{ mt: 0, mb: 8 }}>
        <Grid container spacing={2} bgcolor={"#d5eaff"} className="p-4">
          <Grid item xs={12} md={3} lg={3}>
            {/* Sticky Filter Section */}
            <Box
              sx={
                {
                  //position: "sticky",
                  // top: "70px", // This will keep the element 100px from the top when scrolling
                  // maxHeight: 'calc(100vh - 120px)', // Limit height to viewport minus some space
                  // maxHeight: "100%",
                }
              }
            >
              <SearchFilterSection
                search={search}
                setSearch={setSearch}
                experience={experience}
                setExperience={setExperience}
                skillset={skillset}
                setSkillset={setSkillset}
                location={location}
                setLocation={setLocation}
                jobType={jobType}
                setJobType={setJobType}
                setJobMode={setJobMode}
                department={department}
                setDepartment={setDepartment}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
                applyFilters={() => applyFilters()}
                clearFilters={clearFilters}
                experiences={experiences}
                skillsets={skillsets}
                countries={countries}
                jobTypeOptions={jobTypeOptions}
                jobModeOptions={jobModeOptions}
                departmentOptions={departmentOptions}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={6}>
            <Search onSearchResults={setFilteredJobs} />

            {/* Display Total Jobs Available */}
            <Grid container sx={{marginBottom:"20px",}}>
            <Grid item xs={8}>
            <Typography
              variant="h6"
              fontSize={14}
              sx={{
                color: "#008600",
                display: "inline-block",
                backgroundColor: "#fff",
                border: "solid 1px #008600",
                padding: "4px 8px",
              }}
            >
              Total Job Openings - {totalJobs}
            </Typography>
            </Grid>
            <Grid container justifyContent="flex-end" xs={12} sm={4} sx={{ mt: { xs: 4, sm: 0 } }}>
              {/* Job Mode Filter */}
              <Grid container xs="8"  sx={{paddingRight:"16px"}}>
                <Grid item xs="12" bgcolor={"white"}>
              <FormControl fullWidth 
              //sx={{ minWidth: 120 }} 
              size="small">
                <InputLabel>Job Mode</InputLabel>
                <Select
                  value={jobMode}
                  onChange={(e) => setJobMode(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <AccountBalanceIcon color="primary" sx={{fontSize:"14px"}} />
                    </InputAdornment>
                  }
                  label="jobMode"
                >
                  <MenuItem value="">Select job mode</MenuItem>
                  {jobModeOptions.map((jobMode) => (
                    <MenuItem key={jobMode} value={jobMode}>
                      {jobMode}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              </Grid>
              </Grid>
              <Grid item xs="4"
              sx={{
                
                textTransform: "none",
      fontWeight: "normal",
      padding: "2px 4px",
      backgroundColor: "#fff",
      borderRadius: "4px",
              }}
            >
              <SortIcon
                sx={{ fontSize: "24px", color: "#333", marginRight: 1 }}
              />
              <Select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                variant="standard"
                disableUnderline
                sx={{ fontSize: "14px", color: "#333" }}
              >
                {sortOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            </Grid>
            </Grid>
            {/* <FormControl fullWidth sx={{px:"10px"}}>
            <InputLabel sx={{ fontSize:'13px', marginTop:"2px"}}>Sort By</InputLabel>
            <Select 
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              label="Sort By" 
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&:hover .MuiOutlinedInput-notchedOutline': {border: 'none'},
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {border: 'none'},
              }}
            >
              <MenuItem value="">Default</MenuItem>
              {sortOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              ))}
            </Select>
          </FormControl> */}
            {/* <Button variant="outlined" startIcon={<SortIcon />} sx={{float:"right", textTransform:"none", fontSize:"12px", fontWeight:"normal"}}>Sort By</Button> */}
            <JobListingSection
              jobs={currentJobs}
              handleApply={handleApply}
              currentPage={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              onRefreshNeeded={triggerRefresh}
            />
          </Grid>

          {/* More Jobs Sidebar - now sticky with the component directly rather than in a Grid */}
          {isDesktop && jobs.length > 0 && (
            <Grid item xs={12} md={3} lg={3}>
              {/* Priority Jobs Recommendation Section */}
              <PriorityJobsRecommendation
                jobs={jobs}
                handleApply={handleApply}
              />
              <MoreJobsSidebar allJobs={jobs} handleApply={handleApply} />
            </Grid>
          )}
        </Grid>
        
          <Grid style={{display:"flex", justifyContent:"center", alignItems:"center", margin:"16px 0px"}}>
            <img src={careerAd} style={{height:"auto",}} />
          </Grid>
        
        <Card
          variant="outlined"
          sx={{
            maxWidth: "345px",
            position: "fixed",
            bottom: "32px",
            right: "16px",
            boxShadow: "0px 0px 10px #888",
            paddingTop: "32px",
            display: isVisible ? "block" : "none",
            background: "linear-gradient(45deg, #002791, #b100c6)",
            backgroundSize: "400% 400%",
            animation: `${gradientAnimation} 1s ease infinite`,
            zIndex: "999",
            color: "#fff",
          }}
        >
          <IconButton
            size="small"
            onClick={() => setIsVisible(false)}
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              zIndex: 1,
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>
          <CardContent sx={{ paddingTop: "0px" }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "8px",
                color: "#fff",
              }}
            >
              Simplify HR with Texora
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", color: "#fff", fontSize: "14px" }}
            >
              All-in-one HR software to manage payroll, attendance, leave, and
              more—effortlessly.
              <br />
            </Typography>
            <Typography
              component={Link}
              to="https://texora.ai/"
              variant="h3"
              sx={{
                fontSize: "14px",
                fontWeight: "semibold",
                color: "#000",
                marginTop: "10px",
                backgroundColor: "#fff",
                display: "inline-block",
                padding: "8px 10px",
                border: "none",
                cursor: "pointer",
              }}
            >
              Try Texora free today!
            </Typography>
          </CardContent>
        </Card>
        {/* <div className="whatsAppFixed" style={{position:"fixed", right:"26px", bottom:"100px", zIndex:"9999"}}>
            <a className="hotline_block" style={{padding:"0px"}} href="https://wa.me/+919210970334?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services" target="_blank" >
              <span className="hotline_icon" style={{width:"46px", height:"46px"}}>
                <i className="fa-brands fa-whatsapp fa-bounce" style={{fontSize:"26px"}}></i>
              </span>
            </a>
        </div> */}
        
      </Container>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default CareerPage;
